import './App.css'
import { BrowserRouter } from 'react-router-dom'
import AuthRoute from './routes/authRoute'

function App() {
  return (
    <BrowserRouter>
      <AuthRoute></AuthRoute>
    </BrowserRouter>
  )
}

export default App
